
export const SET_LABELS = 'labels/set-labels';
export const UPDATE_LABEL = 'labels/update-label';
export const REMOVE_LABEL = 'labels/remove-label';
export const SET_ACTIVE_TAB = 'labels/active-tab';
export const SET_LABEL_FILTERS = 'labels/set-filters';
